// extracted by mini-css-extract-plugin
module.exports = {"go-back-to-main-menu":"go-back_go-back-to-main-menu__6EQXx"};